'use client';
import {styled} from '@mui/material/styles';
import {useEffect, useRef, useState} from 'react';
import {HERO_HEIGHT_VAR, heroFrame} from './heroSize';
import {HeroStage} from './HeroStage';
import {HeroMode, type HeroShellProps, type HeroSize} from './types';

// Below this much of the hero left on screen it counts as scrolled away: playback
// pauses and the sound drops until it scrolls back.
const IN_VIEW_RATIO = 0.3;

const Root = styled('section', {shouldForwardProp: propName => propName !== 'oSize'})<{oSize: HeroSize}>(({theme, oSize}) => ({
  ...heroFrame(theme, HeroMode.Static, oSize),
  position: 'relative',
  minHeight: `var(${HERO_HEIGHT_VAR})`,
}));

export function HeroStatic({size, ...content}: HeroShellProps) {
  const rootRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(true);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.intersectionRatio >= IN_VIEW_RATIO);
      },
      {threshold: [0, IN_VIEW_RATIO]},
    );
    observer.observe(root);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Root ref={rootRef} oSize={size}>
      <HeroStage {...content} inView={inView} />
    </Root>
  );
}

HeroStatic.displayName = 'HeroStatic';
